import React from "react";
import { BarChart3, Users2, ShoppingBag, DollarSign, Activity } from "lucide-react";

export default function Overview() {
  const stats = [
    { icon: <Users2 className="w-[12px] h-[12px] text-blue-400" />, label: "Active Users", value: "2,341" },
    { icon: <ShoppingBag className="w-[12px] h-[12px] text-green-400" />, label: "Marketplace Items", value: "847" },
    { icon: <DollarSign className="w-[12px] h-[12px] text-yellow-400" />, label: "Total Revenue", value: "$12,340" },
    { icon: <Activity className="w-[12px] h-[12px] text-pink-400" />, label: "Live Sessions", value: "24" },
  ];

  const recentActivity = [
    { id: 1, title: "New SmartCard Registered", time: "2 hrs ago" },
    { id: 2, title: "KYC Verified: AlgoTradeX", time: "5 hrs ago" },
    { id: 3, title: "New Marketplace Listing Added", time: "Yesterday" },
  ];

  return (
    <div className="p-3 text-white space-y-4 text-[0.7rem]">
      {/* Header */}
      <h1 className="text-[0.75rem] font-semibold flex items-center gap-2 text-slate-200 mb-1 tracking-wide">
        <BarChart3 className="w-[14px] h-[14px] text-blue-400" />
        Dashboard Overview
      </h1>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {stats.map((s, i) => (
          <div
            key={i}
            className="bg-slate-900/70 border border-slate-800 rounded-md p-2 flex flex-col gap-[2px] hover:bg-slate-900 transition"
          >
            <div className="flex items-center gap-2 text-[0.68rem] text-slate-400">
              {s.icon}
              {s.label}
            </div>
            <div className="text-[0.8rem] font-semibold text-slate-200">
              {s.value}
            </div>
          </div>
        ))}
      </div>

      {/* Recent Activity */}
      <div className="bg-slate-900/70 border border-slate-800 rounded-md p-3">
        <h2 className="text-[0.7rem] font-semibold text-slate-300 mb-2">
          Recent Activity
        </h2>
        <ul className="space-y-1">
          {recentActivity.map((a) => (
            <li
              key={a.id}
              className="flex justify-between text-[0.68rem] text-slate-400 border-b border-slate-800/50 pb-1"
            >
              <span>{a.title}</span>
              <span className="text-slate-500">{a.time}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
